/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _shouldComponentUpdate.default;
  }
});
var _shouldComponentUpdate = _interopRequireDefault(require("../packages/shouldComponentUpdate"));


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/shouldComponentUpdate.js
// module id = 218
// module chunks = 0